import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-national-user',
  templateUrl: './national-user.component.html',
  styleUrls: ['./national-user.component.scss']
})
export class NationalUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
